function directive($http) {
    return {
        link: function ($scope, element) {
            $scope.$on('stealthForceChart', function (event, data) {
                var value_offset = 40;
                var trig = d3.select("#stealthforcechart").append("div");

                // var trigger_leggend = trig.selectAll(".trigger_leggend")
                //     .data([''])
                //     .enter().append("button")
                //     .text("Upload")
                //     .style("display","block")
                //     .attr("class", "btnRestore2015")
                //     .style("fill", "#000");

                // $('.sUpload').on('click',function() {
                //     // $scope.triggerScript();
                //     $scope.uploadBtn();
                // });

                var width = $('#stealthforcechart').width();
                var height = width/1.5;
                var tCount = [], link, node;
                let square_width = 30;
                data.links.forEach(function (d) {
                    tCount.push(d.value);
                });
                var maxNum = Math.max.apply(Math, tCount);

                var palette = {
                    "lightgray": "#A4A4A4",
                    "gray": "#708284",
                    "mediumgray": "#536870",
                    "darkgray": "#475B62",
                    "darkblue": "#0A2933",
                    "darkerblue": "#042029",
                    "paleryellow": "#FCF4DC",
                    "paleyellow": "#EAE3CB",
                    "yellow": "#E9D805",
                    "orange": "#FFA500",
                    "red": "#D11C24",
                    "pink": "#C61C6F",
                    "darkpink": "#C61C3A",
                    "purple": "#6364A6",
                    "darkpurple": "#9F5AB7",
                    "blue": "#4273C7",
                    "darkgreen": "#1F5E76",
                    "green": "#259286",
                    "yellowgreen": "#738A05"
                };
                var color = function (group, type) {
                    if (group === 0) { // stealth role/group/coi node
                        if (type === "role") {
                            return palette.green;
                        } else if (type === "group") {
                            return palette.purple;
                        } else if (type === "coi") {
                            return palette.blue;
                        }
                    } else if (group === 1) { // IP node with 1 COI group
                        return palette.lightgray;
                    } else if (group >= 2) { // IP node with 2 COI groups
                        return palette.gray;
                    } else {
                        return palette.red;
                    }
                };
                function logslider(x) {
                    if (x === undefined) {
                        return 18;
                    }
                    var minp = 0;
                    var maxp = maxNum;
                    // the result should be between 100 an 10000000
                    var minv = Math.log(5);
                    var maxv = Math.log(50);
                    // calculate adjustment factor
                    var scale = (maxv-minv) / (maxp-minp);
                    return Math.exp(minv + scale*(x-minp));
                }

                var circleWidth = 5;

                var outVis = d3.select("#stealthforcechart").append('svg')
                        .attr("width", width)
                        .attr("height", height)
                    .call(d3.behavior.zoom().scaleExtent([0.5, 4]).on("zoom", zoom));

                var vis = outVis
                    .append("svg")
                        .attr("class", "stage")
                        .attr("width", width)
                        .attr("height", height)
                    .append('g');

                function zoom() {
                    vis.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                // // add tooltip
                // $scope.tip = d3.tip()
                //     .attr('class', 't-tip')
                //     .offset([0, -100])
                //     .html(function (d) {
                //         var title = "<strong>Rules </strong> <br />";
                //         var rules = "";
                //         for (var i = 0; i < d.rules.length; i++) {
                //             if (d.rules[i].rule !== "-") {
                //                 rules += "&nbsp&nbsp&nbsp" + d.rules[i].order + " " + d.rules[i].rule + "<br />";
                //             }
                //         }
                //         if (rules === "") {
                //             return "<div class='hoverRules'>" + title + "None" + "</div>";
                //         }
                //         else {
                //             return "<div class='hoverRules'>" + title + rules + "</div>";
                //         }
                //     });
                //     vis.call($scope.tip);

                var force = d3.layout.force()
                    .on("tick", tick)
                    .gravity(0.05)
                    .linkDistance(20)
                    .charge(-1500)
                    .size([width-50, height]);

                function dragstart(d) {
                    d3.event.sourceEvent.stopPropagation();
                    d.fixed = true;
                    force.stop();
                }

                function dragmove(d) {
                    d.fixed = true;
                    d.px += d3.event.dx;
                    if ((d.px >= value_offset) && (d.px <= width-value_offset)) {
                        d.x += d3.event.dx;
                    }
                    d.py += d3.event.dy;
                    if ((d.py >= value_offset) && (d.py <= height-value_offset)) {
                        d.y += d3.event.dy;
                    }
                    tick();
                }

                function dragend(d) {
                    d.fixed = true;
                    d.px = d.x;
                    d.py = d.y;
                    $scope.page.save_coordinates(d);
                    tick();
                    force.resume();
                }

                $scope.update = function () {
                    force
                        .nodes(data.nodes)
                        .links(data.links)
                        .start();

                    link = vis.selectAll(".link").data(data.links);
                    link.enter().append("line")
                        .attr("class", "link")
                        .attr("stroke", "#CCC")
                        .attr("fill", "#000")
                        .style("stroke-width", "5");
                    link.exit().remove();

                    var node_drag = d3.behavior.drag()
                        .on("dragstart", dragstart)
                        .on("drag", dragmove)
                        .on("dragend", dragend);

                    node = vis.selectAll(".node").data(data.nodes);
                    node.enter().append("g")
                        .attr("class", "node")
                        .call(node_drag);

                    // CIRCLE
                    node.each(function (d) {
                        if ((d.type === "role") || (d.type === "group")) {
                            d.fixed = true;
                        }
                        var elm = d3.select(this);
                        if (d.hide !== "true") {
                            if (d.gateway === 1) {
                                elm
                                    .append('svg:path')
                                        .attr('transform', 'translate(-18,-18)')
                                        .attr('d', 'M18,0C8.059,0,0,8.06,0,18.001C0,27.941,8.059,36,18,36c9.94,0,18-8.059,18-17.999C36,8.06,27.94,0,18,0z')
                                        .attr('fill', '#67AAB5');
                                elm
                                    .append('svg:path')
                                        .attr('transform', 'translate(-18,-18)')
                                        .attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146'+
                                            'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458'+
                                            'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352'+
                                            'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285'+
                                            'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03'+
                                            'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242'+
                                            'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26'+
                                            'l0.959-3.195l-2.882-1.775L24.715,19.976z')
                                        .attr('fill', '#595A5C');
                            } else if (d.type === "user") {
                                elm
                                        .attr('height', '23')
                                        .attr('width', '23')
                                    .append('svg:path')
                                        .attr('transform', 'translate(-11,-11)')
                                        .attr('d', 'M22,22.5h-3.4c0,0,0-3.5,0-3.5c0-0.5-0.4-1.1-0.9-1.1'+
                                        'c-0.5,0-1,0.5-1,1.1c0,0,0,3.5,0,3.5H5.3c0,0,0-3.3,0-3.5c0-0.5-0.4-1.1-1-1.1c-0.5,0-1,0.5-1,1.1c0,0.1,0,3.5,0,3.5H0'+
                                        'c0,0,0-5.3,0-6.2c0-2.7,2.2-4.8,4.9-4.8c0.2,0,12,0,12.2,0c2.6,0,4.7,1.9,4.9,4.4L22,22.5z M11.1,0C8.4,0,6.2,2.2,6.2,4.9'+
                                        's2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9S13.8,0,11.1,0z')
                                        .style('fill-rule', '#evenodd')
                                        .style('clip-rule', '#evenodd')
                                        .style('fill', function (d) { return  color(d.group, d.type);} );
                            } else if (d.type === "coi") {
                                elm
                                    .append('svg:path')
                                        .attr('fill', palette.blue)
                                        .attr('transform', 'translate(-20,-20)')
                                        .attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828'+
                                            'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439'+
                                            'C28.014,15.545,26.676,21.468,23.587,26.751z');
                            } else if (d.type === "role") {
                                elm
                                    .append("svg:rect")
                                        .attr("x", -(square_width/2))
                                        .attr("y", -(square_width/2))
                                        .attr("width", square_width)
                                        .attr("height", square_width)
                                        .attr("fill", function (d) { return  color(d.group, d.type, d.stealth_version); });
                            } else {
                                elm
                                    .append("svg:circle")
                                        .attr("r", function (d) {return logslider(d["width"]); })
                                        .attr("fill", function (d) { return  color(d.group, d.type, d.stealth_version); });
                            }
                        }
                        elm.on('mouseover', function () {
                            elm.style('cursor', 'pointer')
                        });
                    });
                    // TEXT
                    node.append("text")
                        .text(function (d) { return d.name })
                        .attr("x",    function () { return circleWidth + 5; })
                        .attr("y",            function () { return circleWidth })
                        .attr("font-size",    function () {  return  "1em"; })
                        .attr("text-anchor",  function () { return  "beginning"; });

                    node.append("title").html((d) => {
                        if (d.type === "coi") {
                            var title = "<strong>Rules </strong> <br />";
                            var rules = "";
                            for (var i = 0; i < d.rules.length; i++) {
                                if (d.rules[i].rule !== "-") {
                                    rules += "&nbsp&nbsp&nbsp" + d.rules[i].order + " " + d.rules[i].rule + "<br />";
                                }
                            }
                            if (rules === "") {
                                rules = "None";
                            }
                            return rules
                        }
                        return null;
                    });
                    node.exit().remove();
                };
                $scope.update();

                function tick() {
                    node[0].x = width;
                    node[0].y = height;

                    node.attr("cx", function (d) {
                            return d.x = Math.max(value_offset, Math.min(width - value_offset, d.x));
                        })
                        .attr("cy", function (d) {
                            return d.y = Math.max(value_offset, Math.min(height - (value_offset*5.6), d.y)); });

                    link.attr("x1", function (d) { return d.source.x; })
                        .attr("y1", function (d) { return d.source.y; })
                        .attr("x2", function (d) { return d.target.x; })
                        .attr("y2", function (d) { return d.target.y; });

                    node.attr("transform", function (d) {
                        return "translate(" + d.x + "," + d.y + ")";
                    });
                }

                // LEGEND
                var legend_color = function (legend_item) {
                    if (legend_item === "Stealth Role") {
                        return palette.green;
                    } else if (legend_item === "AD Group") {
                        return palette.purple;
                    } else if (legend_item === "Stealth COI") {
                        return palette.blue;
                    } else if (legend_item === "User with single COI") { // IP node with 1 COI group
                        return palette.lightgray;
                    } else if (legend_item === "User with multiple COIs") { // IP node with 2 COI groups
                        return palette.gray;
                    } else if (legend_item === "Users") { // IP node with 2 COI groups
                        return '#000';
                    } else {
                        return palette.red;
                    }
                };
                var circle_legend_data = ["AD Group"];
                var square_legend_data = ["Stealth Role"];

                var circle_legend = outVis.selectAll(".circle_legend")
                    .data(circle_legend_data)
                    .enter().append("g")
                    .attr("class", "circle_legend")
                    .attr("transform", function (d, i) { return "translate(11," + (i+2.2) * 24 + ")"; });
                circle_legend.append("circle")
                    .attr("r", function (d) {return logslider(d["width"]) - 7; })
                    .style("fill", function (d) { return legend_color(d) });
                circle_legend.append("text")
                    .attr("x",15)
                    .attr("y", 0)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                var square_legend = outVis.selectAll(".square_legend")
                    .data(square_legend_data)
                    .enter().append("g")
                    .attr("class", "square_legend")
                    .attr("transform", function (d, i) { return "translate(11," + (i+circle_legend_data.length+2.3) * 24 + ")"; });
                square_legend.append("rect")
                    .attr("x", -((square_width-8)/2))
                    .attr("y", -((square_width-8)/2))
                    .attr("width", square_width - 8)
                    .attr("height", square_width - 8)
                    .style("fill", function (d) { return legend_color(d) });
                square_legend.append("text")
                    .attr("x",15)
                    .attr("y", 0)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                var legendShield = outVis.selectAll(".legendShield")
                    .data(["Stealth COI"])
                    .enter().append("g")
                    .attr("class", "legendShield")
                    .attr("transform", "translate(-7,88)");
                legendShield.append('svg:path')
                    .attr('fill', palette.blue)
                    .attr('transform', 'translate(0,0)')
                    .attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828'+
                        'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439'+
                        'C28.014,15.545,26.676,21.468,23.587,26.751z');
                legendShield.append("text")
                    .attr("x", 32)
                    .attr("y", 19)
                    .attr("dy", ".35em")
                    .text(function (d) { return d; });

                var legend_data = ["Users"];

                var legend = outVis.selectAll(".legend")
                    .data(legend_data)
                    .enter().append("g")
                    .attr("class", "legend")
                    .attr("transform", function (d, i) { return "translate(11," + (i+1) * 26 + ")"; });
                legend
                    .attr('height', '23')
                    .attr('width', '23')
                    .append('svg:path')
                        .attr('transform', 'translate(-11,-11)')
                        .attr('d', 'M22,22.5h-3.4c0,0,0-3.5,0-3.5c0-0.5-0.4-1.1-0.9-1.1'+
                            'c-0.5,0-1,0.5-1,1.1c0,0,0,3.5,0,3.5H5.3c0,0,0-3.3,0-3.5c0-0.5-0.4-1.1-1-1.1c-0.5,0-1,0.5-1,1.1c0,0.1,0,3.5,0,3.5H0'+
                            'c0,0,0-5.3,0-6.2c0-2.7,2.2-4.8,4.9-4.8c0.2,0,12,0,12.2,0c2.6,0,4.7,1.9,4.9,4.4L22,22.5z M11.1,0C8.4,0,6.2,2.2,6.2,4.9'+
                            's2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9S13.8,0,11.1,0z')
                        .style('fill-rule', '#evenodd')
                        .style('clip-rule', '#evenodd')
                        .style('fill', function (d) { return  legend_color(d)} );

                legend.append("text")
                        .attr("x", 13)
                        .attr("y", 3)
                        .attr("dy", ".35em")
                        .text(function (d) { return d; });

                // var gateway_legend = outVis.selectAll(".gateway_legend")
                //     .data(["Cleartext COI"])
                //     .enter().append("g")
                //     .attr("class", "gateway_legend");

                // gateway_legend
                //     .attr("transform", "translate(0," + (21) + ")" )
                //     .append('svg:path')
                //         .attr('transform', 'translate(0,126)')
                //         .attr('d', 'M18,0C8.059,0,0,8.06,0,18.001C0,27.941,8.059,36,18,36c9.94,0,18-8.059,18-17.999C36,8.06,27.94,0,18,0z')
                //         .attr('fill', '#67AAB5');
                // gateway_legend.append('svg:path')
                //     .attr('transform', 'translate(0,126)')
                //     .attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146'+
                //         'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458'+
                //         'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352'+
                //         'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285'+
                //         'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03'+
                //         'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242'+
                //         'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26'+
                //         'l0.959-3.195l-2.882-1.775L24.715,19.976z')
                //     .attr('fill', '#595A5C');

                // gateway_legend.append("text")
                //     .attr("x", 40)
                //     .attr("y", 144)
                //     .attr("dy", ".35em")
                //     .text(function (d) { return d; });

                $scope.$on('$destroy', function () {
                    element.remove();
                });
            })
        }
    };
}

directive.$inject = ['$http'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/forcechart/stealthforcechart.js
 **/